/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Docs_MdInputs */

const en_serve_docs_md = /** @type {(inputs: Serve_Docs_MdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`## 8. Build on your own computer (\`bystep serve\`)

Use the Claude Code or Codex subscription you already pay for. \`npx @bystep/cli serve\` registers your computer, then picks up the steps you start on Bystep, runs the coding agent locally with your own login, verifies the acceptance criteria and reports the proof back — no Bystep step credits are used. "Try it on your phone" is served through a Bystep link to the app running on your computer. Plain-language setup: [bystep.dev/serve](https://bystep.dev/serve). Check readiness with \`npx @bystep/cli serve --doctor\`.
`)
};

const id_serve_docs_md = /** @type {(inputs: Serve_Docs_MdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`## 8. Bangun di komputer sendiri (\`bystep serve\`)

Pakai langganan Claude Code atau Codex yang sudah kamu bayar. \`npx @bystep/cli serve\` mendaftarkan komputermu, lalu mengambil langkah yang kamu mulai di Bystep, menjalankan agen koding secara lokal dengan login milikmu, memeriksa kriteria terima, dan melaporkan buktinya — jatah langkah Bystep tidak terpakai. "Coba dulu di HP-mu" dilayani lewat tautan Bystep ke aplikasi yang berjalan di komputermu. Panduan awam: [bystep.dev/serve](https://bystep.dev/serve). Cek kesiapan dengan \`npx @bystep/cli serve --doctor\`.
`)
};

/**
* | output |
* | --- |
* | "## 8. Build on your own computer (`bystep serve`) Use the Claude Code or Codex subscription you already pay for. `npx @bystep/cli serve` registers your compu..." |
*
* @param {Serve_Docs_MdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_docs_md = /** @type {((inputs?: Serve_Docs_MdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Docs_MdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_docs_md(inputs)
	return en_serve_docs_md(inputs)
});